<!--
 * @Author: 金小瑞
 * @Date: 2018-07-24 08:51:44
 * @LastEditors: 金小瑞
 * @LastEditTime: 2019-09-05 14:30:11
 * @Description: '详情页 - 客户阶段 - 阶段工作'
 -->
<!-- 
  详情页 - 客户阶段 - 阶段工作
  props:
    id: 详情id
 -->
<template>
	<div class="customer-stage">
    <div class="noSetStage" v-if="!customerStage.id">
      <p class="first">
        <span>暂未设置客户阶段 </span>
        <el-button type="text" v-if="permission" @click="isChangeStage()">跳转至第一阶段</el-button>
      </p>
      <p class="second" v-if="permission">（更多阶段可点击上方的客户阶段标签）</p>
    </div>
    <div class="curStage" v-if="customerStage.id">
      <div class="curStage-title" v-if="customerStage.type !== 2">
        <i class="title-icon" :class="allFinishWork ? 'web-icon-finish' : 'web-icon-progress'"></i>
        <span class="title">{{customerStage.name}} —工作完成{{finishState}}</span>
      </div>
      <div class="curStage-title" v-else>
        <i class="title-icon el-icon-warning lose"></i>
        <span class="title">{{customerStage.name}}</span>
      </div>
      <div class="curStage-content">
        <div class="curStage-work lose-because" v-if="customerStage.type === 2">
          <div class="lose-flex">
            <span class="lose-title">流失原因</span>
            <span class="lose-text">{{wastageReason.reason}}</span>
          </div>
          <div class="lose-flex">
            <span class="lose-title">流失备注</span>
            <p class="lose-text">{{wastageReason.memo}}</p>
          </div>
        </div>
        <div class="curStage-work" v-else>
          <div class="workList" v-if="curWorkArray.length">
            <div class="work-item" v-for="work in curWorkArray" :key="work.id">
              <el-checkbox v-model="work.isFinished" @change="isFinshedWork(work)"><span class="isRequired" v-if="work.isRequired">* </span>{{work.name}}</el-checkbox>
              <p class="hint" v-if="work.isFinished">{{work.userName}}于{{work.finishedTime}}完成</p>
            </div>
            <p class="finish-hint" v-if="allFinishWork">工作全部完成啦！请及时填写反馈并变更阶段哦！</p>
          </div>
          <div class="workList" v-else>
            <p class="noWorkList">该阶段未设置工作指引</p>
          </div>
          <div class="curStage-butArr">
            <span class="feedback" :class="{'open-feedback': curFeedback}" @click="curFeedback = !curFeedback">共{{curCommentArray.length}}条反馈</span>
            <el-button size="mini" @click="isChangeStage()" v-if="permission && isJumpStage">跳转下阶段</el-button>
          </div>
        </div>
        <div class="curStage-feedback" v-if="curFeedback">
          <div class="submit" v-if="permission">
            <stage-comment-box
              refType="customerStage"
              :refId="customerStage.id"
              :customerId="id"
              @refresh="getNowStage">
            </stage-comment-box>
          </div>
          <ul class="com-list" v-if="curCommentArray.length">
            <li class="com-item" v-for="comment in curCommentArray" :key="comment.id">
              <div class="title">
                <span class="name">{{comment.name}}</span>
              </div>
              <div class="avatar">
                <img width="36" height="36" :src="comment.avatar">
              </div>
              <div class="post-time">{{comment.addTime}}</div>
              <div class="desc">
                <span class="at" v-if="comment.refUserName">{{'@' + comment.refUserName}}</span>
                {{comment.content}}
              </div>
              <ul class="gallery-wrap">
                  <li class="img" v-for="img in strToArr(comment.images)" :key="img.uid">
                    <img width="80" height="80" :src="img.url || img" @click="openLightbox(img)">
                  </li>
              </ul>
              <attachment-preview v-if="comment.attachment.length" :data="jsonStringify(comment.attachment)"></attachment-preview>
            </li>
          </ul>
        </div> 
      </div>
    </div>
    <div class="perStage" v-if="historyStageData.length">
      <div class="perStage-title">
        <i class="title-icon web-icon-history"></i>
        <span class="title">历史工作与反馈</span>
      </div>
      <div class="perStage-content">
        <div class="stage-item" v-for="(historyStage, index) in historyStageData" :key="index">
          <p class="perStage-title">
            <span class="name">{{historyStage.customerStage.name}}</span>
            <span class="time">{{historyStage.customerStage.intoTime}}~{{historyStage.customerStage.outTime}} （历时：{{historyStage.customerStage.stayTime}}）</span>
          </p>
          <div class="stage-content">
            <div class="perStage-common perStage-work">
              <span class="type">工作</span>
              <div v-if="!historyStage.workArray.length" class="noFeedback">该阶段未设置工作指引。</div>
              <div class="perStage-work-content" v-else>
                <div class="work-item" v-for="preWork in historyStage.workArray" :key="preWork.id">
                  <el-checkbox label="a" disabled v-model="preWork.isFinished"><span class="isRequired" v-if="preWork.isRequired">* </span>{{preWork.name}}</el-checkbox>
                  <p class="hint" v-if="preWork.isFinished">{{preWork.userName}}，于{{preWork.finishedTime}}完成</p>
                </div>
              </div>
            </div>
            <div class="perStage-common perStage-feedback">
              <span class="type">反馈</span>
              <div v-if="!historyStage.commentArray.length" class="noFeedback">该阶段未填写反馈。</div>
              <div v-else class="perStage-feedback-content">
                <ul class="com-list" >
                  <li class="com-item" v-for="comment in historyStage.commentArray" :key="comment.id">
                    <div class="title">
                      <span class="name">{{comment.name}}</span>
                    </div>
                    <div class="avatar">
                      <img width="36" height="36" :src="comment.avatar">
                    </div>
                    <div class="post-time">{{comment.addTime}}</div>
                    <div class="desc">
                      <span class="at" v-if="comment.refUserName">{{'@' + comment.refUserName}}</span>
                      {{comment.content}}
                    </div>
                    <ul class="gallery-wrap">
                      <li class="img" v-for="img in strToArr(comment.images)" :key="img.uid">
                        <img width="80" height="80" :src="img.url || img" @click="openLightbox(img)">
                      </li>
                    </ul>
                    <attachment-preview v-if="comment.attachment.length" :data="jsonStringify(comment.attachment)"></attachment-preview>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
	</div>
</template>

<script>
import * as api from 'src/api'
import { Message, MessageBox } from 'element-ui'
import lightBox from 'src/plugins/lightbox'
import stageCommentBox from 'components/common/comment-box/stage-comment-box'
import attachmentPreview from 'components/common/attachment-preview'

export default {
  created () {
    this.initDate()
  },
  props: {
    id: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      workList: [],
      fileAttrValue: [],
      curFeedback: true, //
      curWorkArray: [], // 当前阶段工作
      curCommentArray: [], // 当前阶段反馈
      historyStageData: [], // 历史阶段
      customerStage: [], // 客户阶段的一些基本信息
      nextStage: {},
      isJumpStage: true, // 是否可以跳转下一阶段
      allFinishWork: false, // 是否全部完成
      wastageReason: {},
      finishState: '', // 工作完成情况
      permission: false // 权限控制
    }
  },
  methods: {
    // 初始化请求数据
    initDate () {
      this.getNowStage()
      this.getHistoryStage()
    },
    // 请求历史阶段数据
    getHistoryStage () {
      let url = `/customerStage/historyStage.html`
      let params = {
        id: this.id
      }
      api.post(url, params, (data) => {
        this.historyStageData = data.result || []
      })
    },
    // 请求现阶段数据
    getNowStage () {
      let url = `/customerStage/nowStage.html`
      let params = {
        id: this.id
      }
      api.post(url, params, (data) => {
        this.curWorkArray = data.result.workArray || []
        this.curCommentArray = data.result.commentArray || []
        this.customerStage = data.result.customerStage || {}
        this.nextStage = data.nextStage
        this.permission = data.permission
        if (data.result.wastageReason) {
          this.wastageReason = data.result.wastageReason
          this.curFeedback = false
        }
        this.judgeJumpStage()
      })
    },
    // 判断工作情况和是否可以跳转下一阶段
    judgeJumpStage () {
      let finishedNum = 0
      this.isJumpStage = true
      this.curWorkArray.map((item) => {
        if (item.isRequired && !item.isFinished) {
          this.isJumpStage = false
        }
        if (item.isFinished) {
          finishedNum++
        }
      })
      this.finishState = finishedNum + '/' + this.curWorkArray.length
      // 判断工作完成情况
      if (finishedNum === this.curWorkArray.length) {
        this.allFinishWork = true
      } else {
        this.allFinishWork = false
      }
      // 判断是否显示跳转下一阶段
      if (this.customerStage.type === 2 || !this.nextStage.id) {
        this.isJumpStage = false
      }
    },
    // 完成工作
    isFinshedWork (work) {
      if (!this.permission) {
        work.isFinished = !work.isFinished
        Message(`对不起，您没有权限进行此操作`)
        return
      }
      if (!work.isFinished) {
        MessageBox.confirm('当前工作已完成，确定将其变更为未完成状态吗？', '变更工作', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info'
        }).then(() => {
          this.finshedOrcancelWork(work)
        }).catch(() => {
          work.isFinished = true
        })
      } else {
        this.finshedOrcancelWork(work)
      }
    },
    // 完成或者取消工作
    finshedOrcancelWork (work) {
      let url = `/customerStage/finishWork.html`
      let params = {
        customerId: this.id,
        stageLogId: this.customerStage.id,
        refType: 'customerApi',
        workId: work.id,
        isFinished: work.isFinished
      }
      api.post(url, params, (data) => {
        Message({
          type: 'success',
          message: data.msg || '操作成功!'
        })
        this.$emit('refresh')
      }, () => {
        work.isFinished = !work.isFinished
      })
    },
    // 跳转下一阶段
    isChangeStage () {
      MessageBox.confirm(`确认跳转到"${this.nextStage.name}"阶段吗？`, '客户阶段变更', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.changeStage()
      }).catch(() => {
      })
    },
    // 改变阶段
    changeStage () {
      let url = `/customerStage/changeStage.html`
      let params = {
        customerId: this.id,
        nextStageId: this.nextStage.id,
        reasonId: '',
        memo: ''
      }
      api.post(url, params, (data) => {
        Message({
          type: 'success',
          message: data.msg || '操作成功!'
        })
        this.getNowStage()
        this.getHistoryStage()
        this.$emit('refresh')
        if (this.nextStage.type === 1) {
          this.isCreateContract()
        }
      })
    },
    // 是否生成合同
    isCreateContract () {
      MessageBox.confirm(`该客户已经成交，是否生成合同`, '生成合同确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        let params = {
          refId: this.id,
          module: 'contractApi',
          type: 'customerApi'
        }
        this.$emit('createContract', params)
      }).catch(() => {})
    },
    jsonStringify (array) {
      return JSON.stringify(array)
    },
    // 解析JSON数组
    strToArr (str) {
      if (str instanceof Array) {
        return str
      }
      return window.utils.json(str)
    },
    openLightbox (val) {
      if (typeof val === 'object') {
        lightBox(val.url)
      } else {
        lightBox(val)
      }
    }
  },
  components: {
    stageCommentBox,
    attachmentPreview
  }
}
</script>
<style lang="less">
  .customer-stage .work-item {
    .el-checkbox {
      display: flex;
      align-items: center;
      .el-checkbox__label {
        color: #666666 !important;
      }
    }
  }
</style>
<style lang="less" scoped>
  @import '../../../assets/less/detail.less';
  .customer-stage {
    .file-info {
      margin-left: 0;
    }
    .isRequired {
      color: #E51C23;
    }
    .noSetStage {
      margin-top: 24px;
      .first, .second{
        font-size: 14px;
        color: #9b9b9b;
        text-align: center;
      }
      .second {
        font-size: 12px;
      }
    }
    .com-list {
      border-top: 1px dashed #dee8f5;
      .com-item {
        position: relative;
        margin: 0px 0 0 50px;
        border-bottom: 1px solid #dee8f5;
        margin-bottom: 10px;
        padding-bottom: 10px;
        .gallery-wrap {
          font-size: 0;
          .img {
            width: 80px;
            height: 80px;
            margin-right: 19px;
            overflow: hidden;
            display: inline-block;
          }
        }
        &:hover {
          .title {
            .option {
              visibility: visible;
            }
          }
        }
        .title {
          text-align: right;
          line-height: 1;
          padding: 2px 0;
          overflow: hidden;
          vertical-align: top;
          .name {
            font-size: 14px;
            float: left;
            color: #4e617c;
          }
          .option {
            font-size: 13px;
            color: @light-blue;
            padding-right: 12px;
            border-right: 1px solid @light-blue;
            margin-right: 12px;
            visibility: hidden;
            &:last-child {
              margin-right: 0;
              border-right-width: 0;
              padding-right: 0;
            }
            &:hover {
              color: @bg-red;
            }
          }
        }
        .avatar {
          position: absolute;
          left: -46px;
          top: 0;
          width: 36px;
          height: 36px;
        }
        .post-time {
          line-height: 1;
          font-size: 13px;
          color: @light-gray;
          margin-top: 5px;
        }
        .desc {
          font-size: 13px;
          line-height: 1.6;
          padding-bottom: 12px;
          word-break: break-all;
          color: #666666;
          .at {
            color: @primary;
            margin-right: 4px;
          }
        }
        .file {
          margin-bottom: 10px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .file-name {
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }
  .curStage {
    padding: 5px 0;
    .com-list {
      padding-top: 15px;
    }
    .curStage-title {
      display: flex;
      align-items: center;
      margin-bottom: 15px;
      .title-icon {
        font-size: 22px;
        margin-right: 5px;
      }
      .web-icon-progress {
        color: #FE933D;
      }
      .web-icon-finish {
        color: #78E0CF;
      }
      .lose {
        color: #E51C23;
      }
      .title {
        font-size: 14px;
        color: #47494d;
      }
    }
    .curStage-content {
      margin-left: 30px;
      .curStage-work {
        font-size: 14px;
        box-shadow: 0px 0px 0px 0px rgba(239, 239, 239, 1);
        border: 1px solid rgba(229, 236, 247, 1);
        &.lose-because {
          padding: 10px 10px 40px 10px;
          .lose-flex {
            display: flex;
            align-items: baseline;
                line-height: 20px;
            .lose-title {
              flex: 0 0 auto;
              font-size: 12px;
              color: #B9B9B9;
              margin-right: 20px;
            }
            .lose-text {
              font-size: 12px;
              color: #666666;
            }
          }
        }
        .workList {
          padding: 10px 20px;
          .noWorkList {
            text-align: center;
            color: #FF7C35;
            padding: 20px;
          }
          .work-item {
            font-size: 12px;
            color: #666666;
            line-height: 20px;
            margin-bottom: 5px;
            .hint {
              font-size: 11px;
              color: #9b9b9b;
              margin-left: 25px;
            }
          }
          .finish-hint {
            color: #FF7C35;
            margin: 10px 0 10px 10px;
          }
        }
      }
      .curStage-butArr {
        height: 40px;
        line-height: 40px;
        text-align: right;
        background: #F5F9FF;
        border: 1px solid rgba(239, 239, 239, 1);
        .feedback {
          font-size: 12px;
          color: #666666;
          margin-right: 10px;
          text-decoration: underline;
          position: relative;
          cursor: pointer;
          &.open-feedback:after {
            content: "";
            position: absolute;
            width: 0px;
            height: 0px;
            border: 20px solid transparent;
            border-bottom: 20px solid #ffffff;
            top: 0;
            left: 25%;
          }
        }
        .el-button {
          margin-right: 10px;
        }
      }
    }
    .curStage-feedback {
      border: 1px solid #e5ecf7;
      border-radius: 2px;
      padding: 8px 20px 14px 14px;
      .submit {
        border: 1px solid #e5ecf7;
        border-radius: 2px;
        position: relative;
        .enter {
          box-sizing: border-box;
          width: 100%;
          resize: none;
          border: none;
          padding: 8px;
          height: 55px;
          line-height: 22px;
          font-size: 13px;
          font-family: 'microsoft Yahei';
          color: #444;
        }
      }
    }
  }
  .perStage {
   .perStage-title {
      display: flex;
      align-items: center;
      margin: 15px 0;
      .title-icon {
        font-size: 22px;
        color: #6A82A4;
        margin-right: 5px;
      }
      .title {
        font-size: 14px;
        color: #47494d;
      }
    }
    .perStage-content {
      border: 1px solid #E5ECF7;
      border-right: 0;
      border-bottom: 0;
      margin-left: 30px;
      padding: 0 0 15px 15px;
      .stage-item {
        position: relative;
        &:before {
          content: '';
          position: absolute;
          top: 4px;
          left: -20px;
          background: #5E97F5 100%;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          box-sizing: border-box;
        }
        &:after {
          content: '';
          box-sizing: border-box;
          position: absolute;
          top: 0px;
          left: -24px;
          width: 16px;
          height: 16px;
          border: 2px solid #5E97F5;
          border-radius: 50%;
        }
        .perStage-title {
          display: flex;
          align-items: center;
          margin-top: 25px;
          .name {
            font-size: 12px;
            color: #606266;
            margin-right: 10px;
          }
          .time {
            font-size: 10px;
            color: #9b9b9b;
          }
        }
        .stage-content {
          color: rgba(16, 16, 16, 1);
          font-size: 14px;
          box-shadow: 0px 0px 1px 1px rgba(239, 239, 239, 1);
          font-family: Roboto;
          border: 1px solid rgba(229, 236, 247, 1);
          margin-top: 10px;
          padding: 12px;
          .perStage-common {
            display: flex;
            align-items: baseline;
            align-items: flex-start;
            .type {
              flex: 0 0 auto;
              font-size: 12px;
              color: #9b9b9b;
              margin-right: 12px;
            }
            .noFeedback {
              font-size: 12px;
              color: #666666;
            }
          }
          .perStage-work {
            margin-bottom: 12px;
            .work-item {
              font-size: 12px;
              color: #666666;
              line-height: 20px;
              margin-bottom: 5px;
              .hint {
                font-size: 11px;
                color: #9b9b9b;
                margin-left: 25px;
              }
            }
          }
          .perStage-feedback {
            border-top: 1px solid #E5ECF7;
            padding-top: 12px;
            .com-list {
              border-top: 0;
            }
            .perStage-feedback-content {
              flex: 1;
            }
          }
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// customer-stage.vue?c3b91ce6